import { IconButton } from '@material-ui/core';

import Tooltip from '@material-ui/core/Tooltip';
// import InfoIcon from '@material-ui/icons/Info';
// import FileCopyIcon from '@material-ui/icons/FileCopy';
// import MoreIcon from '@material-ui/icons/More';
// import HouseIcon from '@material-ui/icons/House';
import Badge from '@material-ui/core/Badge';
import ChatIcon from '@material-ui/icons/Chat';

import React, { useEffect, useState, useRef } from 'react';
import styles from './styles';
import Drawer from '@material-ui/core/Drawer';
import SideMenu from '../SideMenu';
import useSignal from '../../hooks/useSignal';

export default function MoreOptionsButton({
  classes,
  participants,
  room,
  localParticipant,
  open,
  setOpen,
  pid,
}) {
  const { listOfMessages } = useSignal({ room });
  const titleToolTip = 'Chat';
  const localClasses = styles();
  const [state, setState] = React.useState(false);
  const [openchat, setOpenchat] = useState(false);
  const [showNotificationChat, setShowNotificationChat] = useState(false);
  const prevArrayLength = useRef(listOfMessages.length);
  const toggleOpen = () => {
    setOpen(!open);
    setOpenchat(!openchat);
    setShowNotificationChat(false);
  };

  useEffect(() => {
    if (
      !openchat &&
      listOfMessages.length > 0 &&
      listOfMessages.length > prevArrayLength.current
    ) {
      setShowNotificationChat(true);
    }
    prevArrayLength.current = listOfMessages.length;
  }, [openchat, listOfMessages]);

  return (
    <div>
      {showNotificationChat ? (
        <Tooltip title={titleToolTip} aria-label='add'>
          <Badge badgeContent={1} color='secondary'>
            <IconButton
              onClick={toggleOpen}
              edge='start'
              color='inherit'
              aria-label='mic'
              className={localClasses.infoButton}
            >
              <ChatIcon fontSize='inherit' />
            </IconButton>
          </Badge>
        </Tooltip>
      ) : (
        <Tooltip title={titleToolTip} aria-label='add'>
          <IconButton
            onClick={toggleOpen}
            edge='start'
            color='inherit'
            aria-label='mic'
            className={localClasses.infoButton}
          >
            <ChatIcon fontSize='inherit' />
          </IconButton>
        </Tooltip>
      )}

      <Drawer
        anchor='right'
        open={state}
        classes={{ paper: localClasses.paper }}
      >
        <SideMenu
          className={localClasses.root}
          room={room}
          participants={participants}
          localParticipant={localParticipant}
          listOfMessages={listOfMessages}
          isOpen={true}
          pid={pid}
        ></SideMenu>
      </Drawer>
    </div>
  );
}
